import { Injectable } from '@angular/core';

import { abastecimentoBensStorage, TiposAbastecimentoBens } from "./data.service";
import { UtilService } from "../../../shared/services/util.service";

@Injectable()
export class AbastecimentoBemService {

    constructor(
        private _utilService: UtilService
    ) { }

    //session
    setSessionStorage(item: any) {
        let object: string = JSON.stringify(item);
        sessionStorage.setItem(abastecimentoBensStorage + '-new', object);
    }

    getSessionStorage() {
        let item: string = sessionStorage.getItem(abastecimentoBensStorage + "-new");
        return JSON.parse(item);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(abastecimentoBensStorage + "-new");
    }

    getTipoExterno() {
        return this.getTipoAbastecimento(2);
    }

    getTipoInterno() {
        return this.getTipoAbastecimento(1);
    }

    getTipoConvenio() {
        return this.getTipoAbastecimento(3);
    }

    private getTipoAbastecimento(tipoKey: number) {
        let tipos: any[] = this._utilService.cloneObject(TiposAbastecimentoBens),
            x: any, lenX: any, tipo: any;

        for (x = 0, lenX = tipos.length; x < lenX; x++) {
            if (tipos[x].Key === tipoKey) {
                tipo = tipos[x];
                break;
            }
        }

        return tipo;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/abastecimento-bens/shared/abastecimento-bem.service.ts
 **/